import styled from "styled-components";

const GameInfoListTitle = styled.strong`
  font-weigth: bold;
  text-transform: uppercase;
  color: #fbb700;
`;

export default GameInfoListTitle;
